import * as React from 'react';

// @ts-expect-error
import type {FieldArrayProps, FieldProps} from 'redux-form';

import type {ActivityType} from 'nutshell-core/types';

import {Button} from 'shells/button/button';
import {OptionCardBuilderField} from 'shells/redux-form-fields/option-card/option-card-builder-field';
import type {Option} from 'shells/select-picker-generic/types';

import {GraphQLSelectActivityTypes} from '../../../core/select/graphql-select-activity-types';

import {isNotActivityTypeId} from './activity-type';

import styles from './fields-basic-info.module.css';

type Props = {
    fields: FieldArrayProps['fields'];
    meta: FieldArrayProps['meta'];
    activityTypes: ActivityType[];
    bottomRowText: string;
};

type CardProps = {
    meta: FieldProps['meta'];
    input: FieldProps['input'];
    onRemove: () => any;
};

export class FieldActivityTypes extends React.PureComponent<Props> {
    render() {
        return (
            <div className={styles['card-container']}>
                <OptionCardBuilderField
                    addText='+ Add another activity'
                    divider='Or'
                    fields={this.props.fields}
                    meta={this.props.meta}
                    getCardData={this.getCardData}
                    cardCreator={this.cardCreator}
                />
            </div>
        );
    }

    getCardData = (selected: string) => {
        const selectedActivityType = this.props.activityTypes.find(
            (activityType) => activityType.id === selected
        );

        return {
            topRow: selectedActivityType ? selectedActivityType.name : selected,
            bottomRow: this.props.bottomRowText,
        };
    };

    cardCreator = (cardProps: CardProps) => {
        const selectedIds = this.props.fields.getAll();

        return (
            <div className={styles['activity-type-field']}>
                <GraphQLSelectActivityTypes
                    autoFocus={true}
                    isCreateable={true}
                    selectedId={cardProps.input.value}
                    selectedIds={selectedIds}
                    formatCreateLabel={(label) => `Create activity type "${label}"`}
                    onChange={this.handleChange(cardProps)}
                    isValidNewOption={this.isValidNewOption}
                />
                {this.props.fields.length > 1 ? (
                    <div className={styles['activity-type-field-actions']}>
                        <Button onClick={cardProps.onRemove}>Cancel</Button>
                    </div>
                ) : null}
            </div>
        );
    };

    handleChange = (cardProps: CardProps) => (selected: Option) => {
        cardProps.input.onChange(selected.value);
    };

    isValidNewOption = (inputValue: string): boolean => {
        const isLongEnough = Boolean(inputValue && inputValue.trim().length >= 3);

        return isLongEnough && this.isOptionUnique(inputValue);
    };

    // Check to see if the value entered into the search field for the select
    // doesn't match the name of any existing activity type or any activity type
    // that we have already said we want to create.
    isOptionUnique = (newOption: string) => {
        const selectedIds = this.props.fields.getAll();

        const allActivittyTypeNames = selectedIds
            .filter(Boolean)
            .filter(isNotActivityTypeId)
            // @ts-expect-error
            .map((id) => id.toLowerCase())
            .concat(
                this.props.activityTypes.map((activityType) => activityType.name.toLowerCase())
            );

        return !allActivittyTypeNames.includes(newOption.toLowerCase());
    };
}
